module.exports = __webpack_public_path__ + "img/应急处置机器人.9bd0fb15.png";